import {
    Component, OnInit,
    ViewEncapsulation
} from '@angular/core';
import { AccountSubscriptionsDetailsActionsPaymentMethod } from '../account.subscriptions.details.actions.payment-method';

@Component({
    selector: 'account-subscriptions-details-actions-payment-method-payment-on-shipping',
    templateUrl: './account.subscriptions.details.actions.payment-method.payment-on-shipping.component.html',
    styleUrls: ['./../../../../../account.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class AccountSubscriptionsDetailsActionsPaymentMethodPaymentOnShippingComponent extends
    AccountSubscriptionsDetailsActionsPaymentMethod implements OnInit {

    ngOnInit() {
        this.choose(this.paymentMethod.id);
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src727013012/src/src/app/account/subscriptions/details/actions/payment-method/payment-on-shipping/account.subscriptions.details.actions.payment-method.payment-on-shipping.component.ts